// Helper function to determine if we're in a development environment
const isDevelopment = () => {
  // Check if we're running locally
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1' ||
                     window.location.hostname.includes('192.168.');

  // Check if we're running in development mode (expo)
  const isExpo = window.location.hostname.includes('.expo.dev');
  
  // Check if we're in development mode explicitly
  const forceDev = process.env.REACT_APP_ENV === 'development' || 
                  process.env.NODE_ENV === 'development';

  return isLocalhost || isExpo || forceDev;
};

// Export the development mode flag
export const DEV_MODE = isDevelopment();

// You can add more environment configurations here
export const config = {
  showComingSoon: !DEV_MODE,
  // Add any other environment-specific configurations here
  env: DEV_MODE ? 'development' : 'production',
};

// Log the current environment
console.log('Current environment:', {
  isDev: DEV_MODE,
  hostname: window.location.hostname,
  env: config.env,
}); 